export const ADS = {
        adminPage: 'admin-ads-page',
        newBtn: 'admin-ad-new',
        saveBtn: 'admin-ad-save',
        row: 'admin-ad-row',
        editBtn: 'admin-ad-edit',
        deleteBtn: 'admin-ad-delete',
        toggleBtn: 'admin-ad-toggle',
        topbar: 'topbar-ad',
        topbarClose: 'topbar-ad-close',
        topbarCta: 'topbar-ad-cta',
        popup: 'popup-ad',
        popupClose: 'popup-ad-close',
        popupCta: 'popup-ad-cta',
};
